import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'ElectroSh - Electronic Ithems And Databases',
    }
  },

  // =======================================================
  // =======================USER SIDE=======================
  // =======================================================

  {
    path: '/user',
    component: () => import('../views/user.vue'),
    children: [
      {
        path: '',
        name: 'userProfile',
        component: () => import('../views/users/profile.vue'),
        meta: {
          title: 'ElectroSh - User Profile',
          hasFooter: true,
          user_authorize: []
        }
      },
      {
        path: 'login',
        name: 'userLogin',
        component: () => import('../views/users/login.vue'),
        meta: {
          title: 'ElectroSh - User Login'
        }
      },
      {
        path: 'register',
        name: 'userRegister',
        component: () => import('../views/users/register.vue'),
        meta: {
          title: 'ElectroSh - User Registration'
        }
      },
      {
        path: 'reset',
        name: 'ResetPassword',
        component: () => import('../views/users/ResetPassword.vue'),
        meta: {
          title: 'ElectroSh - Password Reset'
        }
      },
      {
        path: 'forget',
        name: 'IsForgetPassword',
        component: () => import('../views/users/IsForgetPassword.vue'),
        meta: {
          title: 'ElectroSh - Forget Password'
        }
      }
    ]
  },
  {
    path: '/products',
    component: () => import('../views/products.vue'),
    children: [
      {
        path: '',
        name: 'products',
        component: () => import('../views/products/productsAll.vue'),
        meta: {
          title: 'ElectroSh - Products',
          isWishlist: false
        }
      },
      {
        path: 'categories',
        name: 'categories',
        component: () => import('../views/products/ProductsCategories.vue'),
        meta: {
          title: 'ElectroSh - Product Categories'
        }
      },
      {
        path: ':id(\\d+)',
        name: 'ProductView',
        component: () => import('../views/products/ProductView.vue'),
        meta: {
          title: 'ElectroSh - Product',
          // user_authorize: []
        }
      },
      {
        path: 'wishlist',
        name: 'wishlist',
        component: () => import('../views/products/productsAll.vue'),
        meta: {
          title: 'ElectroSh - Products Wishlist',
          isWishlist: true
        }
      },
      {
        path: 'cart',
        name: 'cart',
        component: () => import('../views/cart.vue'),
        meta: {
          title: 'ElectroSh - Products Cart'
        }
      },
      {
        path: 'track',
        name: 'orderTrack',
        component: () => import('../components/products/OrderTrackingComponent.vue'),
        meta: {
          title: 'ElectroSh - Order Tracking',
          headerAndFooter: true,
        }
      }
    ]
  },

  // ======================================================
  // ===================SUPPER USER SIDE===================
  // ======================================================

  {
    path: '/dashboard',
    component: () => import('../views/dashboard.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('../views/dashboard/Dashboard.vue'),
        meta: {
          title: 'ElectroSh - Dashboard',
          supper_authorize: []
        }
      },
      {
        path: 'home',
        name: 'dashboardHome',
        component: () => import('../views/dashboard/DashBoardHome.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Home]',
          supper_authorize: []
        }
      },
      {
        path: 'categories',
        name: 'dashboardCategories',
        component: () => import('../views/dashboard/DashboardCategories.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Categories]',
          supper_authorize: []
        }
      },
      {
        path: 'products',
        name: 'dashboardProducts',
        component: () => import('../views/dashboard/DashBoardProducts.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Products]',
          supper_authorize: []
        }
      },
      {
        path: 'analytics',
        name: 'dashboardAnalytics',
        component: () => import('../views/dashboard/DashboardAnalytics.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Analytics]',
          supper_authorize: []
        }
      },
      {
        path: 'customers',
        name: 'dashboardCustomers',
        component: () => import('../views/dashboard/DashBoardCustomers.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Customers]',
          meta: { requiresAuth: true },
          supper_authorize: []
        }
      },
      {
        path: 'settings',
        name: 'dashboardSettings',
        component: () => import('../views/dashboard/DashboardSettings.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Settings]',
          supper_authorize: []
        }
      },
      {
        path: 'profile',
        name: 'dashboardUserProfile',
        component: () => import('../views/dashboard/SupperUserProfile.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Profile]',
          hasFooter: false,
          supper_authorize: []
        }
      },
      {
        path: 'pos',
        name: 'posSystem',
        component: () => import('../views/dashboard/Saling/pos.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [POS System]',
          hasFooter: false,
          supper_authorize: []
        }
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('../views/dashboard/Saling/orders.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [orders System]',
          hasFooter: false,
          supper_authorize: []
        }
      },
      {
        path: 'store',
        name: 'store',
        component: () => import('../views/dashboard/Saling/store.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [store System]',
          hasFooter: false,
          supper_authorize: []
        }
      },
      {
        path: 'logs',
        component: () => import('../views/dashboard/DashboardLogs.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [logs]',
          hasFooter: false,
          supper_authorize: []
        }
      },
      {
        path: 'login',
        name: 'supperUserLogin',
        component: () => import('../views/dashboard/Supperlogin.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Login]',
          hasFooter: false
        }
      },
      {
        path: 'reset',
        name: 'SupperResetPassword',
        component: () => import('../views/dashboard/SupperResetPassword.vue'),
        meta: {
          title: 'ElectroSh - Password Reset'
        }
      },
      {
        path: 'forget',
        name: 'SupperForgetPassword',
        component: () => import('../views/dashboard/IsForgetPassword.vue'),
        meta: {
          title: 'ElectroSh - Forget Password'
        }
      },
      {
        path: 'Unauthorized',
        name: 'dashboardUnauthorized',
        component: () => import('../views/Unauthorized.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Unauthorized]',
          hasFooter: false
        }
      },
      {
        path: 'test',
        name: 'dashboard test',
        component: () => import('../views/dashboard/DashboardTest.vue'),
        meta: {
          title: 'ElectroSh - Dashboard [Testing]',
          hasFooter: false
        }
      }
    ]
  },

  // =======================================================
  // =====================DOCUMANTATION=====================
  // =======================================================

  {
    path: '/docs',
    component: () => import('../views/Educational/Documentation.vue'),
    children: [
      {
        path: '',
        name: 'introduction',
        component: () => import('../views/Educational/Documentation/introduction/SiteIntroduction.vue'),
        meta: {
          title: 'ElectroSh - Documantation [introduction]',
          authorize: []
        }
      },
      {
        path: 'electronics',
        name: 'electronics',
        component: () => import('../views/Educational/Documentation/introduction/ElectronicIntroduction.vue'),
        meta: {
          title: 'ElectroSh - Documantation [electronics]',
          authorize: []
        }
      }, {
        path: 'toc',
        name: 'TableOfContent',
        component: () => import('../views/Educational/Documentation/introduction/TableOfContent.vue'),
        meta: {
          title: 'ElectroSh - Documantation [Table Of COntent]',
          authorize: []
        }
      },
    ]
  }

  // =======================================================
  // ======================Contacts=========================
  // =======================================================
  ,{
    path: '/contacts',
    children: [
      {
        path: 'ai',
        name: 'aiChat',
        component: () => import('../views/Communication/ChatWithAI.vue'),
        meta: {
          title: 'ElectroSh - [AI - Chat]',
          authorize: []
        }
      },

      {
        path: 'q&a',
        name: 'q&a',
        component: () => import('../views/Communication/QectionsAnsAnswers.vue'),
        meta: {
          title: 'ElectroSh - [Q & A]',
          authorize: []
        }
      },

      {
        path: 'report',
        name: 'report',
        component: () => import('../views/Communication/ReportIssues.vue'),
        meta: {
          title: 'ElectroSh - [Report]',
          authorize: []
        }
      },

      {
        path: 'suggestions',
        name: 'suggestions',
        component: () => import('../views/Communication/Suggestions.vue'),
        meta: {
          title: 'ElectroSh - [Suggestions]',
          authorize: []
        }
      }
    ]
  }


  // =======================================================
  // ===================INDUSTRIAL SAF======================
  // =======================================================

  ,{
    path: '/site/safety',
    component: () => import('../views/Educational/IndustrialSafety.vue'),
    children: [
      {
        path: '',
        name: 'safetyIntroduction',
        component: () => import('../views/Educational/Documentation/introduction/SiteIntroduction.vue'),
        meta: {
          title: 'ElectroSh - Documantation [introduction]',
          authorize: []
        }
      }
    ]
  }

  // =======================================================
  // =========================Blogs=========================
  // =======================================================
  , {
    path: '/site/blog',
    name: 'blogs',
    component: () => import('../views/Educational/Blog.vue'),
    meta: {
      title: 'ElectroSh - Blogs',
    }
  }

  // =======================================================
  // =========================News=========================
  // =======================================================
  , {
    path: '/site/news',
    name: 'news',
    component: () => import('../views/Educational/News.vue'),
    meta: {
      title: 'ElectroSh - Blogs',
    }
  },


  // =======================================================
  // ========================Datasheets========================
  // =======================================================

  {
    path: '/site/datasheets',
    name: 'datasheets',
    component: () => import('../views/Educational/Datasheets.vue'),
    meta: {
      title: 'ElectroSh - About'
    }
  },


  // =======================================================
  // ========================HELPERS========================
  // =======================================================

  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: {
      title: 'ElectroSh - About'
    }
  },
  {
    path: '/site/version',
    name: 'version',
    component: () => import('../views/others/Versions.vue'),
    meta: {
      title: 'ElectroSh - version Report'
    }
  }, {
    path: '/test',
    name: 'test',
    component: () => import('../views/test.vue'),
    meta: {
      title: 'ElectroSh - Test',
      authorize: []
    }
  }, {
    path: '/Unauthorized',
    name: 'Unauthorized',
    component: () => import('@/views/Unauthorized.vue'),
    meta: {
      title: 'ElectroSh - Unauthorized Route'
    }
  }, {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/404.vue'),
    meta: {
      title: 'ElectroSh - Invalid Route'
    }
  }
]

export default routes;


